module.exports = __webpack_public_path__ + "static/media/icon-dot-gov.cdd13dd3.svg";